import { setProperty } from '../../../../common-utilities/utils/misc';
import { modalConstants } from '../config/constants';

export const modalHandler = (data, type, setConfig) => {
  switch (type) {
    case modalConstants.update:
      setProperty(
        'modalDetails',
        { type, data, title: 'Update CF Mapping' },
        setConfig
      );
      break;
    case modalConstants.create:
      setProperty(
        'modalDetails',
        { type, data: null, title: 'Create CF Mapping' },
        setConfig
      );
      break;
    case modalConstants.delete:
      setProperty(
        'modalDetails',
        { type, data, title: 'Delete CF Mapping' },
        setConfig
      );
      break;
    default:
      break;
  }
};
